<template>
  <div>
    <div class="position-relative dinA4">
      <img :src="require('@/assets/additional-header.png')" class="page__header" />
      <div class="page__container">
        <table class="full-width mt-0 additional-services-table">
          <tr class="primary-background">
            <th class="primary-background h1 color-white text-left pl-4 mb-0 pb-1">
              SERVICIOS COMPLEMENTARIOS
            </th>
            <th class="primary-background h1 color-white text-left pl-4 mb-0 pb-1" />
          </tr>
          <template v-if="this.getAdditionalServiceById('EDP').value !== undefined">
            <table class="full-width table-no-highlight body-2">
              <tr class="mb-0">
                <td class="no-margins">
                  Uso de Puntos Collectt Express
                </td>
              </tr>
              <tr class="no-margins my-0">
                <td class="no-margins">
                  <ul>
                    <li>
                      Disponibles más de 20.000 puntos Collectt Express de servicio en toda la península ibérica, Islas Baleares, Azores
                      y
                      Madeira.
                    </li>
                    <li>
                      Recuerda que para poder hacer uso de los Puntos Collectt Express los envíos deben cumplir las
                      siguientes
                      características:
                      <ul>
                        <li>Envío de 1 solo bulto / Peso máximo igual a 20 Kg.</li>
                        <li>Suma de medidas > 160 cm (60 x 40 x 60).</li>

                      </ul>
                      Este servicio no admite:
                      <ul>
                        <li>Servicio de retorno / Reembolsos / Portes debidos </li>
                        <li>Gestión en destino / Escaneo de albarán / Validación DNI</li>
                      </ul>
                    </li>
                  </ul>
                </td>
              </tr>
            </table>
            <tr>
              <td class="body-2">
                Servicio de entrega directa en punto. Los usuarios pueden retirar sus envíos en los puntos de servicio.
                Descuento
                aplicable a cada envío para entrega directa en punto (EDP).
              </td>
              <td class="body-2 text-center">
                <template v-if="Number(getAdditionalServiceById('EDP').value) === 0">
                  {{ $t('NOT_INCLUDED') }}
                </template>
                <template v-else>
                  -{{ getAdditionalServiceById('EDP').value }}<span class="euro-symbol">€</span>
                </template>
              </td>
            </tr>
          </template>
          <template v-if="this.getAdditionalServiceById('RDP').value !== undefined">
            <tr>
              <td class="body-2">
                Servicio de recogida directa en punto. Los usuarios pueden depositar sus envíos / devoluciones en los
                puntos.
                Descuento aplicable a cada envío para recogida directa en punto*
              </td>
              <td class="body-2 text-center">
                <template v-if="Number(getAdditionalServiceById('RDP').value) === 0">
                  {{ $t('NOT_INCLUDED') }}
                </template>
                <template v-else>
                  -{{ getAdditionalServiceById('RDP').value }}<span class="euro-symbol">€</span>
                </template>
              </td>
            </tr>
            <tr>
              <td class="body-2">
                *El tiempo de compromiso de servicio se adquiere desde la recogida en el punto, que se hará dependiendo
                de los horarios de las rutas establecidas en cada zona. Si el depósito se realiza despues del paso del
                conductor, será recogido al dia hábil siguiente, adquiriendo el compromiso de entrega a partir de esa
                fecha.
              </td>
            </tr>
          </template>
        </table>
        <!-- <p class="body-2 mt-6 mb-0 justify-text">
          (1) <b>Tarjeta CTT PLUS:</b> El uso de la tarjeta CTT PLUS está indicado para clientes que
          cuentan con un equipo de personas (comerciales, mecánicos, asesores, abogados, peritos,
          etc.) que viajan constantemente y tengan la necesidad de solicitar un servicio en
          cualquiera de nuestras agencias CTT Express con cargo a su empresa.
        </p>
        <p class="body-2 mt-6 mb-0 justify-text">
          (2) Cualquier envío que conlleve la impresión de un documento en la oficina de origen o
          destino hasta 5 hojas o adicionales para su posterior recogida / entrega como si de un
          envío normal se tratara.
        </p> -->
      </div>

      <Footer logo :page="previousPages + 1" />
    </div>
  </div>
</template>

<script>
import Footer from '@/containers/offer-form/sign-off/pdf-venta-directa-2024/Footer'

export default {
  name: 'AdditionalServices2',
  components: { Footer },
  data() {
    return {
      previousPages: 0,
    }
  },
  methods: {
    hasAdditionalService(id) {
      return Object.keys(this.$parent.getAdditionalServiceById(id)).length > 0
    },
    getAdditionalServiceById(id) {
      return this.$parent.getAdditionalServiceById(id)
    },
    getAdditionalServiceByDesc(desc) {
      return this.$parent.getAdditionalServiceByDesc(desc)
    },
  },
  mounted() {
    this.previousPages = this.$parent.sectionPreviousPages('AdditionalServices2');
  },
}
</script>

<style>
.additional-services-table td {
  vertical-align: top;
}

.no-margins {
  padding-top: 0 !important;
  padding-bottom: 0 !important;
}
</style>
